<template>
  <div class="backgroud-white cs-channel-editor" v-loading="loading || isInit">
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form ref="form" :rules="rules" :model="model" label-width="100px">
        <el-form-item label="所属国家" prop="countryCode">
          <el-select
            class="input-width"
            v-model="model.countryCode"
            placeholder="请选择所属国家"
          >
            <el-option
              v-for="(item, index) in countryList"
              :key="index"
              :label="item.Value"
              :value="item.Key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属地区" prop="area">
          <el-input
            placeholder="请输入所属地区"
            v-model="model.area"
            class="input-width"
          ></el-input>
        </el-form-item>
        <el-form-item label="渠道名称" prop="name">
          <el-input
            placeholder="请输入渠道名称"
            v-model="model.name"
            class="input-width"
          ></el-input>
        </el-form-item>
        <el-form-item label="使用货币" prop="currency">
          <el-select
            class="input-width"
            v-model="model.currency"
            placeholder="请选择使用货币"
          >
            <el-option
              v-for="(item, index) in GLOBAL.currencyType.getOptions()"
              :key="index"
              :label="item.desc"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="固定佣金" prop="fixedCommissionPercentage">
          <el-input
            placeholder="请输入固定佣金"
            v-model="model.fixedCommissionPercentage"
            class="input-width"
          >
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="梯度佣金">
          <gradedCommission
            v-for="(item, index) in model.gradedCommissionList"
            :key="index"
            :dataIn="{ index: index, model: item }"
            @delete="onDelete"
          ></gradedCommission>
          <el-button
            size="medium"
            type="text"
            icon="el-icon-plus"
            @click="addGradedCommission()"
            >添加新梯度</el-button
          >
        </el-form-item> -->
        <el-form-item label="续购佣金" prop="renewCommissionPercentage">
          <el-input
            placeholder="请输入续购佣金"
            v-model="model.renewCommissionPercentage"
            class="input-width"
          >
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="收款类型" prop="payeeType">
          <el-select
            class="input-width"
            v-model="model.payeeType"
            placeholder="请选择收款类型"
            @change="onPayeeTypeChange"
          >
            <el-option
              v-for="(item, index) in GLOBAL.enumPayeeType.getOptions()"
              :key="index"
              :label="item.desc"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="model.payeeType === GLOBAL.enumPayeeType.Channel" label="启用底价模式" prop="enableBottomPriceMode">
          <el-checkbox v-model="model.enableBottomPriceMode" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col :span="24" class="text-center">
          <span v-if="!showError"></span>
          <el-alert
            :closable="false"
            v-if="showError"
            v-bind:title="errorMessage"
            type="error"
            show-icon
          ></el-alert>
        </el-col>
        <el-col class="text-center" :span="24">
          <el-button
            :disabled="submitBtnDisable"
            :type="submitBtnClass"
            @click="onSave()"
            >{{ isAdded ? "确认添加" : "保存更新" }}</el-button
          >
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cs-channel-editor {
  color: black;
  h6 {
    font-weight: bold;
  }
  /deep/ .el-form-item__label {
    color: black;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>

<script>
import { getChannel, saveChannel } from "../../service/studyAbroad.service";
import { getCountryList, getCurrencyList } from "../../service/common.service";
import gradedCommission from "./gradedCommission";

export default {
  props: {
    dataIn: {
      id: Number,
    },
    dialogVisible: false,
  },
  data() {
    let validateValue = (rule, value, callback) => {
      if (!value) {
        callback();
      } else {
        let message = "";
        let pattern = /^\d+(\.\d+)?$/g;
        let isValid = pattern.test(value);
        if (!!value && !isValid) {
          message = "请输入正确的数字";
        }

        if (!!message) {
          callback(new Error(message));
        } else {
          callback();
        }
      }
    };

    return {
      model: {
        id: 0,
        area: "",
        name: "",
        countryCode: 86,
        currency: 1,
        fixedCommissionPercentage: undefined,
        renewCommissionPercentage: undefined,
        payeeType: 0,
        enableBottomPriceMode: false,
        gradedCommissionList: [
          // {
          //   Id: 0,
          //   MinValue: undefined,
          //   MaxValue: undefined,
          //   CommissionPercentage: undefined,
          // },
        ],
      },
      countryList: [],
      submitBtnClass: "primary",
      submitBtnDisable: false,
      isAdded: false,
      showError: false,
      loading: false,
      isInit: false,
      errorMessage: "",
      rules: {
        area: [
          {
            required: true,
            trigger: "blur",
            message: "请输入区域",
          },
        ],
        name: [
          {
            required: true,
            trigger: "blur",
            message: "请输入名称",
          },
        ],
        fixedCommissionPercentage: [
          {
            validator: validateValue,
            trigger: "blur",
          },
        ],
        renewCommissionPercentage: [
          {
            validator: validateValue,
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    gradedCommission,
  },
  created() {
    this.isInit = true;
    getCountryList().then((result) => {
      if (result && result.success) {
        this.countryList = result.data;
        this.checkIsInit();
      }
    });
    this.loadData();
  },
  methods: {
    onDelete(index) {
      this.$confirm(`您确定要删除该梯度佣金吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.model.gradedCommissionList.splice(index, 1);
        })
        .catch(() => {});
    },
    checkIsInit() {
      if (this.countryList.length > 0) {
        this.isInit = false;
      }
    },
    loadData() {
      if (!!this.dataIn && !!this.dataIn.id) {
        this.isAdded = false;
        this.loading = true;
        getChannel(this.dataIn.id).then((result) => {
          if (!!result && result.success) {
            this.model.id = result.data.Id;
            this.model.area = result.data.Area;
            this.model.name = result.data.Name;
            this.model.countryCode = result.data.CountryCode;
            this.model.currency = result.data.Currency;
            this.model.fixedCommissionPercentage =
              result.data.FixedCommissionPercentage;
            this.model.renewCommissionPercentage =
              result.data.RenewCommissionPercentage;
            this.model.payeeType = result.data.PayeeType;
            this.model.enableBottomPriceMode = result.data.EnableBottomPriceMode;
            this.model.gradedCommissionList = result.data.GradedCommissionList;
          }
          this.loading = false;
        });
      } else {
        this.isAdded = true;
        this.model = {
          id: 0,
          area: "",
          name: "",
          countryCode: 86,
          currency: 1,
          fixedCommissionPercentage: undefined,
          renewCommissionPercentage: undefined,
          payeeType: 0,
          enableBottomPriceMode: false,
          gradedCommissionList: [
            // {
            //   Id: 0,
            //   MinValue: undefined,
            //   MaxValue: undefined,
            //   CommissionPercentage: undefined,
            // },
          ],
        };
      }
    },
    onPayeeTypeChange() {
      if (this.model.payeeType !== this.GLOBAL.enumPayeeType.Channel) {
        this.model.enableBottomPriceMode = false;
      }
    },
    onSave() {
      if (!this.checkAllInputs()) {
        return;
      }

      let rows = [];
      for(let i = 0; i < this.model.gradedCommissionList.length; i ++){
        if (!this.model.gradedCommissionList[i].CommissionPercentage){
          rows.push(i + 1);
        }
      }
      if (rows.length > 0){
        let rowsText = rows.join(", ");
        let msg = `梯度佣金行${rowsText}请输入佣金`;
        this.$message.error(msg);
        return;
      }

      saveChannel(this.model).then((result) => {
        if (result && result.success) {
          this.model.id = result.data;
          this.$message.success("保存成功");
          this.$emit("saveSuccess");
        }
      });
    },
    addGradedCommission() {
      let item = {
        Id: 0,
        MinValue: undefined,
        MaxValue: undefined,
        CommissionPercentage: undefined,
      };
      this.model.gradedCommissionList.push(item);
    },
    checkAllInputs() {
      let isValid = true;
      this.$refs.form.validate((valid) => {
        if (!valid) {
          isValid = false;
          return;
        }
      });
      return isValid;
    },
  },
  watch: {
    dataIn: function () {
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/studyAbroad/channelEditor.vue